module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/linux.a4e1f238.svg";